<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">
                {{ $t("sectionMensagemPadrao.mensagempadraoTitle") }}</strong
              >
              <a
                class="ml-auto btn btn-primary"
                href="/#/mensagem-padrao/novo"
                :title="$t('btAdicionar')"
              >
                {{ $t("btAdicionar") }}
              </a>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              :empty-text="
                $t('sectionMensagemPadrao.mensagempadraoNenhumaMensagem')
              "
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                    variant="warning"
                    style="margin-right: 10px;"
                    :title="$t('btEditar')"
                    @click="Editar(data.item)"
                  >
                    <i class="fa fa-edit text-black"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    :title="$t('btRemover')"
                    @click="Remover(data.item)"
                  >
                    <i class="fas fa-trash-alt text-black"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <!-- <b-modal v-model="modalShow">Hello From Modal!</b-modal> -->
            <b-modal
              v-model="modalRemover"
              :title="$t('textConfirmaExclusao')"
              header-bg-variant="danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              {{ $t("textConfirmaExclusao") }}
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "MensagemPadrao",
  components: {
    RotateSquare
  },
  data() {
    return {
      locale: this.$i18n.locale,
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 0
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "descricao",
          label: this.$t("sectionMensagemPadrao.mensagempadraoDescricao"),
          sortable: true,
          tdClass: "CustomTd"
        },
        {
          key: "texto",
          label: this.$t("sectionMensagemPadrao.mensagempadraoTexto"),
          sortable: true,
          tdClass: "CustomTd"
        },
        {
          key: "acoes",
          label: this.$t("sectionMensagemPadrao.mensagempadraoAcoes"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  beforeMount() {
    this.ObterGrid(1);
  },
  methods: {
    Editar(valor) {
      this.$router.push("/mensagem-padrao/editar/" + valor.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      this.$http({
        url:
          "mensagem-padrao/remover/" +
          this.itemRemover.id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "DELETE"
      })
        .then(() => {
          this.ObterGrid(1);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    ObterGrid(pagina) {
      this.loading = true;
      this.$http({
        url:
          "/mensagem-padrao/obter-grid/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "/" +
          pagina,
        method: "GET"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style>
.CustomTd {
  /* overflow: hidden;
  max-width: 75ch; */
  max-width: 50ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
